
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Building } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const CompanyNotFound = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex items-center mb-4">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => navigate('/companies')} 
          className="mr-2"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Companies
        </Button>
      </div>
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-12">
          <Building className="h-12 w-12 text-muted-foreground mb-4" />
          <h2 className="text-xl font-semibold mb-2">Company Not Found</h2>
          <p className="text-muted-foreground mb-6">
            The company you're looking for doesn't exist or you don't have permission to view it.
          </p>
          <Button onClick={() => navigate('/companies')}>
            Go to Companies
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default CompanyNotFound;
